<template>
  <div class="rebind" :class="$platformClass">
    <Content
      class="quession-title"
      :class="$platformClass"
      type="passportTips"
      v-html="bindTips"
    ></Content>
    <form class="quession-form">
      <Editor
        v-model="code"
        :class="$platformClass"
        editorClass="editor email-send"
        class="editor-wrapper email-send relative"
        :type="$isOmni ? 'emailEditor' : 'passportAccountEditor'"
        :placeholder="languages.enterEmailVrfcationTips"
      >
        <AcountDownBtn
          class="sendEmailBtn w200"
          @countDown="sendVrCode2Email()"
          v-bind:countTime="60"
          type="button"
        >
          {{ languages.reGetVrfCode }}
        </AcountDownBtn>
      </Editor>
      <Block
        tagName="label"
        type="editorWrapper"
        class="agree-wrapper email-send-btn"
        :class="$platformClass"
      >
        <Button
          class="btn account-setting-submit"
          :type="$isOmni ? 'lightfill' : 'fillLight'"
          @click="submit"
        >
          <Icon type="commonBtnLeft"></Icon>
          <Icon type="commonBtnRight"></Icon>
          {{ languages.submit }}
        </Button>
      </Block>
    </form>
  </div>
</template>
<script>
import AcountDownBtn from './AcountDownBtn';
import { VARIFY_EMAIL_REF } from '../../store/passport/accountSetting';
export default {
  props: ['languages', 'accountEmail', 'ckcode', 'email'],
  data() {
    return {
      code: this.ckcode,
    };
  },
  computed: {
    bindTips() {
      return this.languages.rebindEmailTips.replace(
        '$email',
        this.accountEmail
      );
    },
  },
  components: {
    AcountDownBtn,
  },
  methods: {
    sendVrCode2Email() {
      this.$emit('sendVrCode2Email', {
        ref: VARIFY_EMAIL_REF,
        email: this.accountEmail,
      });
    },
    submit() {
      this.$emit('submit', this.code);
    },
  },
};
</script>
